import config from './config.json';
import prodConfig from './prodConfig.json';
import testConfig from './testConfig.json';
import local from './local.json';

export const getConfig = () => {
    // Use environment variable first, then fallback to config.json
    const env = process.env.REACT_APP_ENV || config.environment || 'prod';
    
    switch (env) {
        case 'prod':
            return prodConfig;
        case 'test':
            return testConfig;
        case 'local':
            return local;
        default:
            throw new Error(`Invalid environment specified: ${env}`);
    }
};